import { render } from "./Downloads.vue?vue&type=template&id=64971727"
const script = {}
script.render = render

export default script